var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8c00",
    d: "M0 .9h200V199H0V.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.6 184.8c-12.9-1.4-23.7-10.6-26.9-23.4-.9-5-.9-9.9 0-14.7 1.6-6 5-11.5 9.6-15.8 5.7-5.1 12.9-7.8 20.5-7.6 14 0 26.2 9.2 29.9 22.9 1.2 5.3 1.2 10.8 0 16.1-4.1 14.4-17.9 23.9-33.1 22.5zm-33-130.4h72.3v18.8H18.6V54.4zm0 36.2h72.3v18.8H18.6V90.6zm90.7-36.4h72.3V73h-72.3V54.2zm0 36.2h72.3v18.8h-72.3V90.4zm0 36.1h72.3v18.8h-72.3v-18.8zM18.6 19h72.3v18.8H18.6V19zm90.7-.2h72.3v18.8h-72.3V18.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOData);
export default __webpack_public_path__ + "static/media/OData.293428fa.svg";
export { ForwardRef as ReactComponent };